<template>
  <v-container class="px-0">
    <component :is="detailComponent" :details="details" :loading="loading" />
  </v-container>
</template>

<style>
</style>

<script>
import apiService from '@/services/shared/agentPortalApiService.js';
import analyticsService from '@/services/shared/analyticsService.js';
import coverageTranslator from '@/services/clientViewer/coverageTranslator.js';
import { mapState, mapActions } from 'vuex';

import BoatDetails from '@/components/Client/LineOfBusiness/Vehicles/Vehicle/BoatDetails.vue';
import VehicleDetails from '@/components/Client/LineOfBusiness/Vehicles/Vehicle/VehicleDetails.vue';
import DisplayField from '@/components/Shared/DisplayField.vue';
import AdditionalInterests from '@/components/Shared/AdditionalInterests.vue';

export default {
  name: 'Details',
  components: {
    AdditionalInterests,
    BoatDetails,
    DisplayField,
    VehicleDetails
  },
  data: function () {
    return {
      loading: true,
      details: null,
      viewingMore: false,
      interestSelected: false,
      selectedInterest: null
    };
  },
  computed: {
    ...mapState(['selectedLineOfBusinessCode']),
    clientId: function () {
      return this.$route.params.clientId;
    },
    policyOrderNumber: function () {
      return this.$route.params.policyOrderNumber;
    },
    lobCode: function () {
      return this.selectedLineOfBusinessCode;
    },
    vehicleId: function () {
      return this.$route.params.vehicleId;
    },
    detailComponent: function () {
      return this.isBoat ? 'BoatDetails' : 'VehicleDetails';
    },
    isBoat: function () {
      return ((this.details || null) !== null) && this.details.type === 1;
    }
  },
  created: async function () {
    this.loading = true;

    var rs = await apiService.getVehicleDetails(this.clientId, this.policyOrderNumber, this.lobCode, this.vehicleId);
    if (rs.code === 0) {
      if ((rs.data || null) !== null && rs.data.length > 0) {
        this.details = rs.data[0];
        if ((this.details.summaryCoverages || null) !== null) {
          this.details.summaryCoverages = this.details.summaryCoverages.map(x => coverageTranslator.translateCoverage(x));
        }
      } else {
        this.details = null;
      }
    } else {
      this.setError(rs.message || 'An error occurred.');
    }

    analyticsService.sendEvent(this.$gtag, 'Button Click', 'Policy', this.isBoat ? 'Boat Boats Boat' : 'Auto Vehicles Vehicle');
    this.loading = false;
  },
  methods: {
    ...mapActions(['setError'])
  }
};
</script>
